













import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';
import WithKeyring from '@/utils/WithKeyring';
import { KeyringPair } from '@polkadot/keyring/types';

@Component
export default class AccountSelect extends Mixins(WithKeyring) {
  @Prop() public value!: string | KeyringPair;
  @Prop() public asKeyring!: boolean;
  @Prop({ default: 'Account' }) public label!: boolean;


  get options() {
    return this.keyringAccounts;
  }

  get account(): string {
    return typeof this.value === 'string' ? this.value : this.value.address;
  }

  set account(accountValue: string) {
    console.log('this._account', accountValue)
    if (this.asKeyring) {
      this.$emit('input', this.getPair(accountValue))
    } else {
      this.$emit('input', accountValue)
    }
    
  }

}
